<template>
  <b-row>
    <template v-for="profile in companyFields.filter((el) => el.group_id == 1)">
      <template
        v-if="
          profile.field_profile_type_id == 29 &&
          companyForm.company_information === 'จดทะเบียน'
        "
        :set="
          (field =
            $v.companyForm[checkIsProfile(profile.field_profile_type_id)])
        "
        :id="'field-' + profile.profile_name"
      >
        <b-col md="6">
          <InputRadioGroup
            :textFloat="profile.profile_name"
            v-model="companyForm[checkIsProfile(profile.field_profile_type_id)]"
            className="mb-2"
            :options="
              profile.field_choices.map((x) => ({
                text: x.name,
                value: x.name,
              }))
            "
            @onDataChange="
              (val) =>
                handleChange(val, checkIsProfile(profile.field_profile_type_id))
            "
            :validateText="profile.validate_text"
            :isValidate="field.$error"
            :v="field"
          ></InputRadioGroup>
        </b-col>

        <template v-if="companyForm.company_branch_type == 'สาขา'">
          <b-col md="6">
            <InputText
              textFloat="ชื่อสาขา"
              placeholder="ชื่อสาขา"
              v-model="companyForm.company_branch"
              isRequired
              :isValidate="$v.companyForm.company_branch.$error"
              :v="$v.companyForm.company_branch"
            >
            </InputText>
          </b-col>
          <b-col md="6">
            <InputText
              isRequired
              textFloat="รหัสสาขา"
              placeholder="รหัสสาขา"
              class="mb-2"
              :isValidate="$v.companyForm.company_branch_no.$error"
              :v="$v.companyForm.company_branch_no"
              v-model="companyForm.company_branch_no"
            >
            </InputText>
          </b-col>
        </template>
      </template>
      <b-col
        md="6"
        v-else-if="
          profile.field_profile_type_id !== 22 &&
          profile.field_profile_type_id !== 29
        "
        :key="'field-' + profile.name"
      >
        <div
          :set="
            (field =
              $v.companyForm[checkIsProfile(profile.field_profile_type_id)])
          "
          :id="'field-' + profile.profile_name"
        >
          <b-row v-if="profile.field_type_id == 1">
            <b-col>
              <InputText
                :disabled="
                  companyForm.is_id_card == 1 &&
                  profile.field_profile_type_id !== 10
                "
                :textFloat="changeName(profile)"
                :placeholder="changeName(profile)"
                class="margin-input f-regular"
                :type="checkFieldConditon(profile)"
                :name="profile.profile_name"
                :isRequired="profile.required"
                :class="{
                  'mb-2': profile.field_profile_type_id !== 10,
                }"
                :validateText="
                  profile.field_profile_type_id == 10
                    ? 'กรุณากรอกเบอร์โทรศัพท์ 10 หลัก'
                    : ''
                "
                :isValidate="field.$error"
                :v="field"
                v-model="
                  companyForm[checkIsProfile(profile.field_profile_type_id)]
                "
              />
            </b-col>
            <b-col
              v-if="profile.field_profile_type_id == 10"
              cols="3"
              class="pl-0"
            >
              <InputText
                textFloat="ต่อ"
                placeholder="ต่อ"
                class="margin-inputf-regular"
                :type="checkFieldConditon(profile)"
                :name="profile.profile_name"
                :class="{
                  'mb-2': profile.field_profile_type_id !== 10,
                }"
                v-model="ext.tel"
            /></b-col>
            <b-col cols="12" v-if="profile.field_profile_type_id == 10">
              <p
                class="text-right text-link my-2"
                @click="addTel()"
                v-if="profile.field_profile_type_id == 10"
              >
                เบอร์โทรศัพท์สำรอง
              </p></b-col
            >
          </b-row>

          <b-row
            v-else-if="[2, 21, 28].includes(profile.field_profile_type_id)"
          >
            <b-col
              :md="profile.field_profile_type_id == 2 && otherPrefix ? 6 : 12"
            >
              <InputSelect
                :disabled="
                  !companyForm.company_type &&
                  profile.field_profile_type_id == 2
                "
                :title="profile.profile_name"
                :placeholder="profile.profile_name"
                :isRequired="profile.required"
                v-model="
                  companyForm[checkIsProfile(profile.field_profile_type_id)]
                "
                valueField="value"
                textField="text"
                :options="
                  profile.field_profile_type_id == 28
                    ? companyTypeChoice.map((x) => ({
                        text: x.name,
                        value: x.name,
                      }))
                    : prefixChoices
                "
                className="mb-2"
                @onDataChange="
                  (val) => {
                    (companyForm[
                      checkIsProfile(profile.field_profile_type_id)
                    ] = val),
                      handleChangeDropdown(
                        checkIsProfile(profile.field_profile_type_id),
                        val
                      );
                  }
                "
                :validateText="profile.validate_text"
                :isValidate="field.$error"
                :v="field"
              >
                <template v-slot:option-first>
                  <b-form-select-option :value="null" disabled
                    >-- {{ profile.profile_name }} --</b-form-select-option
                  >
                </template></InputSelect
              ></b-col
            >
            <b-col v-if="otherPrefix && profile.field_profile_type_id == 2">
              <InputText
                v-model="companyForm.otherPrefix"
                textFloat=" "
                placeholder="คำนำหน้าธุรกิจ"
              ></InputText>
            </b-col>
          </b-row>
          <div v-else-if="profile.field_profile_type_id == 27">
            <InputRadioGroup
              :textFloat="profile.profile_name"
              v-model="
                companyForm[checkIsProfile(profile.field_profile_type_id)]
              "
              className="mb-2"
              :options="
                profile.field_choices.map((x) => ({
                  text: x.name,
                  value: x.name,
                }))
              "
              isRequired
              @onDataChange="
                (val) =>
                  handleChange(
                    val,
                    checkIsProfile(profile.field_profile_type_id),
                    profile.field_choices
                  )
              "
              :validateText="profile.validate_text"
              :isValidate="field.$error"
              :v="field"
            ></InputRadioGroup>
          </div>

          <div v-if="profile.field_type_id == 7" class="datetime-container">
            <datetime
              :disabled="companyForm.is_id_card == 1"
              type="date"
              textFloat="วันเกิด "
              name="birthday"
              :ref="'data-picker' + profile.name"
              placeholder="วันเกิด"
              :format="'dd/MM/yyyy'"
              :class="[
                'date-picker-input',
                'date-filter',
                {
                  'border-red': field.$error,
                },
              ]"
              value-zone="Asia/Bangkok"
              v-model="
                companyForm[checkIsProfile(profile.field_profile_type_id)]
              "
              @input="
                (val) =>
                  (companyForm[checkIsProfile(profile.field_profile_type_id)] =
                    val)
              "
              :maxDatetime="now"
              class="datetime-h mb-2"
              :validateText="field.validate_text"
              :isValidate="field.$error"
            >
              <label for="startDate" slot="before">
                {{ profile.name }}
                <span
                  class="text-danger"
                  v-if="
                    checkRequired(checkIsProfile(profile.field_profile_type_id))
                  "
                  >*
                </span>
              </label>
              <font-awesome-icon icon="calendar-alt" />
              <span
                class="description text-danger text-error"
                slot="after"
                v-if="field.$error"
                >กรุณากรอกข้อมูล
              </span>
            </datetime>
            <div
              class="calendar-icon"
              :class="{
                'calendar-icon-top': field.$error,
              }"
              @click="$refs['date-picker' + profile.name].isOpen = true"
            >
              <font-awesome-icon icon="calendar-alt" />
            </div>
          </div>
          <div
            v-else-if="profile.field_type_id == 5"
            class="datetime-container"
          >
            <datetime
              :disabled="companyForm.is_id_card == 1"
              type="date"
              :textFloat="changeName(profile)"
              :name="profile.profile_name"
              :ref="'data-picker' + profile.name"
              :placeholder="changeName(profile)"
              :format="'dd/MM/yyyy'"
              :class="[
                'date-picker-input',
                'date-filter',
                {
                  'border-red': field.$error,
                },
              ]"
              v-model="
                companyForm[checkIsProfile(profile.field_profile_type_id)]
              "
              class="datetime-h mb-2"
              :validateText="field.validate_text"
              :isValidate="field.$error"
            >
              <label for="startDate" slot="before"
                >{{ profile.name }}
                <span
                  class="text-danger"
                  v-if="
                    checkRequired(checkIsProfile(profile.field_profile_type_id))
                  "
                  >*
                </span>
              </label>
              <font-awesome-icon icon="calendar-alt" />
              <span
                class="description text-danger text-error"
                slot="after"
                v-if="field.$error"
                >กรุณากรอกข้อมูล
              </span>
            </datetime>
            <div
              class="calendar-icon"
              :class="{
                'calendar-icon-top': field.$error,
              }"
              @click="$refs['date-picker' + profile.name].isOpen = true"
            >
              <font-awesome-icon icon="calendar-alt" />
            </div>
          </div>

          <div v-else-if="profile.field_type_id == 8">
            <label v-if="changeName(profile)">
              {{ changeName(profile) }}
            </label>
            <InputUploadImage
              :disabled="companyForm.is_id_card == 1"
              :id="profile.id"
              :label="changeName(profile)"
              :img="companyForm[checkIsProfile(profile.field_profile_type_id)]"
              v-model="
                companyForm[checkIsProfile(profile.field_profile_type_id)]
              "
              :v="field"
              @setFileName="
                (val) => setImageName(val, profile.field_profile_type_id)
              "
              :validateText="field.validate_text"
              :isValidate="field.$error"
            />
            <div class="f-12 color-gray mt-1 mb-2">
              ไฟล์ที่อัพโหลดต้องเป็นไฟล์นามสกุล PDF, PNG ,JPG ขนาดไม่เกิน 2.5 mb
              เท่านั้น
            </div>
          </div>
        </div>
      </b-col>
    </template>
  </b-row>
</template>
<script>
import { fieldInForm2, profile_fields2 } from "@/assets/json/fieldProfile.js";
import InputText from "@/components/inputs/InputText";
import InputRadioGroup from "@/components/inputs/InputRadioGroup";
import InputDatePickerFilter from "@/components/inputs/InputDatePickerFilter";
import InputSelect from "@/components/inputs/InputSelect";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputUploadImage from "../../inputs/InputUploadImage.vue";
export default {
  components: {
    InputSelect,
    InputText,
    InputDatePickerFilter,
    InputRadioGroup,
    InputUploadImage,
    InputTextArea,
  },
  props: {
    companyForm: {
      type: Object,
    },
    companyFields: {
      type: Array,
    },
    $v: {
      type: Object,
    },
    ext: {
      type: undefined,
    },
    documentFields: {
      type: Array,
    },
  },
  data() {
    return { companyTypeChoice: [], prefixChoices: [], otherPrefix: false };
  },
  created() {
    console.log(this.companyForm.telephone)
    if (this.companyForm.telephone && this.companyForm.telephone.includes("-")) {
      let phone = this.companyForm.telephone.split("-");
      this.companyForm.telephone = phone[0];
      this.ext.tel = phone[1];
    }

    let typeChoice = this.companyFields
      .find((n) => n.id == 27)
      .field_choices.find((x) =>
        this.companyForm.company_information
          ? this.companyForm.company_information == x.name
          : x.name == "จดทะเบียน"
      );

    this.companyTypeChoice = typeChoice.denpendent;
    if (this.companyForm.company_type) {
      this.prefixChoices = this.companyTypeChoice
        .find((x) => x.name == this.companyForm.company_type)
        .level3.map((x) => ({
          text: x.choice_dependent_name,
          value: x.choice_dependent_name,
        }));
      if (this.companyForm.prefix == "อื่นๆ") {
        this.otherPrefix = true;
      }
      let checkPrefix = this.prefixChoices.find(
        (x) => x.text === this.companyForm.prefix
      );
      if (!checkPrefix) {
        this.companyForm.otherPrefix = this.companyForm.prefix;
        this.companyForm.prefix = "อื่นๆ";
        this.otherPrefix = true;
      }
    }
  },
  methods: {
    checkIsProfile(val) {
      if (val == 99) val = 22;
      const findField = fieldInForm2.find((el) => el.id == val);
      return findField ? findField.key : false;
    },
    changeName($fields) {
      return $fields.field_language[0]
        ? $fields.field_language[0].name
        : $fields.name;
    },
    checkFieldConditon(obj) {
      return obj.field_conditions[0] ? obj.field_conditions[0].value : "text";
    },
    addTel() {
      this.$emit("AddOptionalTelephone");
    },
    async setImageName(val, id) {
      let res = await this.checkIsProfile(id);
      if (res == "id_card_image") this.companyForm.id_card_file_name = val;
    },
    handleChange(val, field, profile) {
      this.companyForm[field] = val;

      if (profile) {
        this.$emit("changeInformation", val);
        this.companyForm.company_branch_type = "สำนักงานใหญ่";
        this.companyForm.company_type = null;
        this.companyForm.prefix = null;
        let type = profile.find((x) => x.name == val);
        this.companyTypeChoice = type.denpendent;
        this.otherPrefix = false;
        this.companyForm.otherPrefix = "";
      }
    },
    handleChangeDropdown(field, val) {
      if (field == "company_type") {
        this.companyForm.prefix = null;
        this.prefixChoices = this.companyTypeChoice
          .find((x) => x.name == val)
          .level3.map((x) => ({
            text: x.choice_dependent_name,
            value: x.choice_dependent_name,
          }));
        this.otherPrefix = false;
        this.companyForm.otherPrefix = "";
      } else if ((field = "prefix")) {
        return (this.otherPrefix = val == "อื่นๆ");
      }
    },
  },
};
</script>
<style lange="scss" scoped>
::v-deep .custom-select:disabled {
  background-color: #d8dbe0 !important;
}

::v-deep input:disabled {
  background-color: #d8dbe0 !important;
}
.text-link {
  font-size: 14px !important;
  text-decoration: underline;
  cursor: pointer;
  color: var(--primary-color) !important;
}

label {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: bold !important;
  width: 100%;
  position: relative;
}

::v-deep .vdatetime-input {
  border-radius: 5px !important;
  /* padding: 8px 10px; */

  height: 35px !important;
}

.border-red {
  ::v-deep .vdatetime-input {
    border-color: red !important;
  }
}
.calendar-icon {
  position: absolute;
  top: 50%;
  right: 3%;
}
.calendar-icon-top {
  top: 35% !important;
}
.datetime-container {
  position: relative;
}

.title-18px {
  color: #333 !important;
  font-size: 18px !important;
  font-weight: bold !important;
  width: 100%;
  position: relative;
}

.input-type ::v-deep .custom-select {
  width: 150px;
}
</style>
